import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  clientMenu: {
    '& .MuiTypography-root': {
      fontSize: 16,
      fontWeight: 500,
      whiteSpace: 'normal',
      color: '#000',
    },
    '& .MuiListItemIcon-root': {
      minWidth: theme.spacing(5),
    },
  },
  clientMenuDark: {
    '& .MuiTypography-root': {
      fontSize: 16,
      fontWeight: 500,
      whiteSpace: 'normal',
      color: '#FFF',
    },
    '& .MuiListItemIcon-root': {
      minWidth: theme.spacing(5),
    },
  },

  optionButtons: {
    margin: theme.spacing(1),
    minHeight: 30,
    minWidth: 30,
    padding: '4px 4px',
  },
  divider: {
    marginTop: 10,
    marginBottom: 10,
  },
}));
